import { AxnSelectedServiceOfferingSO } from "@idw-types/data/reference-data/axn";
import { Assertion } from "@idw-types/data/reference-data/generic";
import {
    VerificationTransactionDetailsAssertionScoreModifier,
    FormattedVerificationTransactionDetailsAssertionScoreModifier
} from "@idw-types/data/verification-transaction-details";
import { safelyParseIntFromString } from "@utils/string-util";

export const formatVerificationTransactionDetailsAssertionScoreModifiers = (
    assertionScoreModifiers: Array<VerificationTransactionDetailsAssertionScoreModifier>,
    assertions: Array<Assertion>,
    serviceOfferings: Array<AxnSelectedServiceOfferingSO>
): Array<FormattedVerificationTransactionDetailsAssertionScoreModifier> => {
    return assertionScoreModifiers.map(modifier => formatVerificationTransactionDetailsAssertionScoreModifier(modifier, assertions, serviceOfferings));
};

export const formatVerificationTransactionDetailsAssertionScoreModifier = (
    assertionScoreModifier: VerificationTransactionDetailsAssertionScoreModifier,
    assertions: Array<Assertion>,
    serviceOfferings: Array<AxnSelectedServiceOfferingSO>
): FormattedVerificationTransactionDetailsAssertionScoreModifier => {
    const assertion = assertions.find(a => a.id === assertionScoreModifier.assertionID);
    const serviceOffering = serviceOfferings.find(so => so.id === assertionScoreModifier.serviceOfferingID);
    let dateCreated = null;
    if (assertionScoreModifier.dateCreated) {
        dateCreated = new Date(parseInt(assertionScoreModifier.dateCreated));
    }

    return {
        assertion: assertion,
        assertionScoreBreakdownID: assertionScoreModifier.assertionScoreBreakdownID,
        claimAssertionScore: safelyParseIntFromString(assertionScoreModifier.claimAssertionScore),
        claimStatus: assertionScoreModifier.claimStatus,
        dateCreated: dateCreated,
        id: assertionScoreModifier.id,
        maxPotentialScore: safelyParseIntFromString(assertionScoreModifier.maxPotentialScore),
        orderNumber: assertionScoreModifier.orderNumber,
        rpSelectedAssertionID: assertionScoreModifier.rpSelectedAssertionID,
        rpServiceAssertionScoreModifierID: assertionScoreModifier.rpServiceAssertionScoreModifierID,
        serviceOffering: serviceOffering,
        totalAssertionScoreAfter: safelyParseIntFromString(assertionScoreModifier.totalAssertionScoreAfter),
        totalAssertionScoreBefore: safelyParseIntFromString(assertionScoreModifier.totalAssertionScoreBefore),
        wasApplied: assertionScoreModifier.wasApplied
    };
};